module.exports = __webpack_public_path__ + "80941e05c7c4563124b1dd874683789d.webp";